import * as React from "react";
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { showAlreadyLoggedInNotice } from '@services/accountLink/accountLink.actions';
import { hasAuthToken } from '@services/user/user.utils';
import { SETTINGS_PATH } from './safeReturn';

interface IProps extends RouteComponentProps {
  loggedIn: boolean;
  showAlreadyLoggedInNotice: () => void;
}

// For pages that act on an account link as soon as they mount. A logged-in user
// never gets the page: they are sent to Settings, where logout is, and told to
// log out first. Decided once on entry, so logging in through the link works.
export function loggedOutOnly(Page: React.ComponentType<any>) {
  class LoggedOutOnly extends React.Component<IProps> {
    public static page = Page;
    private readonly blocked: boolean = this.props.loggedIn;

    public componentDidMount() {
      if (this.blocked) {
        this.props.showAlreadyLoggedInNotice();
      }
    }

    public render() {
      if (this.blocked) {
        return <Redirect to={SETTINGS_PATH}/>;
      }
      const { loggedIn, showAlreadyLoggedInNotice: _, ...routeProps } = this.props;
      return <Page {...routeProps}/>;
    }
  }

  return connect(
    (state: any) => ({ loggedIn: hasAuthToken(state) }),
    { showAlreadyLoggedInNotice }
  )(LoggedOutOnly);
}



// WEBPACK FOOTER //
// ./src/router/loggedOutOnly.tsx